// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CoLabelPopup_title__3xYZO {
  font-size: 20px;
  font-weight: 400;
  line-height: 36px;
}

.CoLabelPopup_content__P9Mho {
  font-size: 16px;
  font-weight: 300;
  line-height: 28px;
  margin: 10px auto;
}

.CoLabelPopup_select__JUuOw {
  margin: 27px auto;
  text-align: left;
}

.CoLabelPopup_button__qjG0p {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/CoLabelPopup/CoLabelPopup.module.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAKJ;;AAHA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAMJ;;AAJA;EACI,iBAAA;EACA,gBAAA;AAOJ;;AALA;EACI,WAAA;AAQJ","sourcesContent":["@use 'styles/colors.scss';\n\n.title{\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 36px;\n}\n.content{\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 28px;\n    margin: 10px auto;\n}\n.select{\n    margin: 27px auto;\n    text-align: left;\n}\n.button{\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"title": `CoLabelPopup_title__3xYZO`,
	"content": `CoLabelPopup_content__P9Mho`,
	"select": `CoLabelPopup_select__JUuOw`,
	"button": `CoLabelPopup_button__qjG0p`
};
export default ___CSS_LOADER_EXPORT___;
